module.exports = "<app-side-menu></app-side-menu>\n\n<div class=\"main-view-container\">\n    <router-outlet></router-outlet>\n</div>\n"